export const AppendText = ({ svg, width, heightTop, curValue }: any) => {
  const textValue = svg.append('g').attr('class', 'middleText')
  textValue
    .append('circle')
    .attr('cx', width / 2 + 0.5)
    .attr('cy', heightTop - 12)
    .attr('fill', '#6B5F6C')
    .attr('r', 2)

  textValue
    .append('text')
    .style('text-anchor', 'middle')
    .attr('x', width / 2 + 0.5)
    .attr('y', heightTop - 18)
    .text(Number(curValue).toFixed(2))
    .attr('class', 'text')
}
